(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let teardown = () => {};
  function init() {
    teardown();
    const landing = document.querySelector('[data-resurrection-root]');
    const product = document.querySelector('#content.nf-rp');
    const root = landing || product;
    if (!root || !document.body.classList.contains('nf-resurrection-world')) return;
    const controller = new AbortController();
    const { signal } = controller;
    const animations = new Set();
    const observers = [];
    const seen = new WeakSet();
    const pointer = matchMedia('(min-width: 990px) and (pointer: fine)');
    const allowMotion = () => !reduced.matches && !window.Shopify?.designMode && (!landing || landing.classList.contains('rp-motion')) && !navigator.connection?.saveData;
    const progress = document.createElement('div');
    progress.className = 'nf-scroll-progress';
    progress.setAttribute('aria-hidden', 'true');
    document.body.append(progress);
    const nav = landing?.querySelector('.rp-nav');
    const links = [...(nav?.querySelectorAll('.rp-nav__link') || [])];
    const chapters = [...(landing?.querySelectorAll('[data-rp-chapter]') || [])];
    const hero = landing?.querySelector('.rp-hero');
    const media = hero?.querySelector('.rp-hero__media');
    const header = document.querySelector('.section-header');
    let headerHeight = 0, frame = 0, activeId = '';
    function measureHeader() {
      headerHeight = header?.getBoundingClientRect().height || 0;
      document.body.style.setProperty('--nf-header-height', `${Math.round(headerHeight)}px`);
    }
    function paint() {
      frame = 0;
      const max = document.documentElement.scrollHeight - innerHeight;
      progress.style.transform = `scaleX(${max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0})`;
      if (media && hero && allowMotion() && pointer.matches) {
        const rect = hero.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < innerHeight) media.style.setProperty('--nf-depth', `${Math.min(36, Math.max(-12, -rect.top * .075)).toFixed(1)}px`);
      }
      if (!chapters.length) return;
      const offset = headerHeight + (nav?.offsetHeight || 0) + innerHeight * .22;
      let current = chapters[0];
      for (const chapter of chapters) {
        if (chapter.getBoundingClientRect().top <= offset) current = chapter;
      }
      if (current.id === activeId) return;
      activeId = current.id;
      links.forEach(link => {
        const active = link.hash === `#${activeId}`;
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(paint);
    }
    const animate = (element, frames, delay = 0, duration = 650) => {
      if (!element.animate || !allowMotion()) return;
      const animation = element.animate(frames, { duration, delay, easing: 'cubic-bezier(.16,.8,.24,1)', fill: 'backwards' });
      animations.add(animation);
      animation.finished.catch(() => {}).finally(() => animations.delete(animation));
    };
    const reveal = (element) => {
      if (seen.has(element)) return;
      seen.add(element);
      element.dataset.nfRevealed = 'true';
      element.classList.add('is-visible');
      const peers = [...element.parentElement.children].filter(e => e.matches('[data-rp-reveal],.rp-shop-card,.nf-edition__details li'));
      const delay = Math.min(160, Math.max(0, peers.indexOf(element)) * (innerWidth < 750 ? 45 : 65));
      animate(element, [{ opacity: .12, translate: '0 24px' }, { opacity: 1, translate: '0 0' }], delay, innerWidth < 750 ? 520 : 700);
      const meter = element.querySelector('.rp-meter span');
      if (meter) animate(meter, [{ transform: 'scaleX(.08)' }, { transform: 'scaleX(1)' }], delay + 80, 850);
      const photo = element.matches('.nf-edition__media') ? element.querySelector('img') : null;
      if (photo) animate(photo, [{ transform: 'scale(1.045)' }, { transform: 'scale(1)' }], 0, 1000);
    };
    const targets = landing ? [...landing.querySelectorAll('[data-rp-reveal],.rp-shop-card')] : [...product.querySelectorAll('.nf-edition__media,.nf-edition__copy,.nf-edition__details li,.product-description,.nf-crucifix-facts,.nf-crucifix-dossier,.section-apps:has(.jdgm-review-widget),.section-product-recommendations')];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: .01, rootMargin: '0px 0px -36px 0px' });
      targets.forEach(target => {
        if (target.getBoundingClientRect().top < innerHeight) { seen.add(target); target.classList.add('is-visible'); }
        else observer.observe(target);
      });
      observers.push(observer);
    } else targets.forEach(reveal);
    root.addEventListener('focusin', event => {
      const target = targets.find(target => target.contains(event.target));
      if (target) reveal(target);
      animations.forEach(animation => { if (animation.effect?.target?.contains(event.target)) animation.cancel(); });
    }, { signal });
    reduced.addEventListener('change', () => {
      animations.forEach(animation => animation.cancel());
      media?.style.removeProperty('--nf-depth');
      schedule();
    }, { signal });
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', () => { measureHeader(); schedule(); }, { passive: true, signal });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) animations.forEach(animation => animation.finish());
      else schedule();
    }, { signal });
    if (header && 'ResizeObserver' in window) {
      const observer = new ResizeObserver(() => { measureHeader(); schedule(); });
      observer.observe(header);
      observers.push(observer);
    }
    measureHeader();
    paint();
    root.dataset.nfPolished = 'true';
    teardown = () => {
      controller.abort();
      observers.forEach(observer => observer.disconnect());
      animations.forEach(animation => animation.cancel());
      cancelAnimationFrame(frame);
      progress.remove();
      media?.style.removeProperty('--nf-depth');
      delete root.dataset.nfPolished;
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  window.addEventListener('pagehide', () => teardown());
  window.addEventListener('pageshow', event => { if (event.persisted) init(); });
})();
